module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/arrow-e59d946797eddee3a12aae0f52fec9c1.svg";